/**
 * ScriptReadPane — the script rendered read-only inside the right Tools panel
 * while a note has the center stage (Notepad full-screen swap).
 */
import React from "react";
import { BookText } from "lucide-react";

export function ScriptReadPane({ elements, title }) {
  return (
    <div className="flex flex-col h-full min-h-0" data-testid="script-read-pane">
      <div className="flex items-center gap-2 px-3 py-2 border-b border-[var(--line)] bg-[var(--paper)] shrink-0">
        <BookText size={13} className="text-[var(--brand)]" strokeWidth={1.75} />
        <span className="text-[10px] uppercase tracking-widest text-[var(--ink-muted)] font-sans truncate">
          {title ? `${title} — read only` : "Script — read only"}
        </span>
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto p-2 bg-[#efe9df]">
        <div
          className="screenplay-page mobile-format"
          style={{ minHeight: "auto", width: "100%", padding: "16px 14px", cursor: "default", boxShadow: "0 1px 4px rgba(0,0,0,0.08)" }}
        >
          {(elements || []).map((el) => (
            <div key={el.id} className={`script-line el-${el.type}`}>{el.text}</div>
          ))}
        </div>
      </div>
    </div>
  );
}
